import { injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable } from 'mobx';
import { FC } from 'react';

export interface ContentFooterItem {
    id: string;
    comp?: FC;
}

@injectable()
export class ContentStore {
    @observable private footers: ContentFooterItem[] = [];

    @computed get footer() {
        return this.footers.find(f => !!f.comp);
    }

    constructor() {
        makeObservable(this);
    }

    @action registerFooter = (id: string, comp?: FC): void => {
        const footer = this.footers.find(f => f.id === id);

        if (footer) {
            this.footers = this.footers.map(f => ({ id, comp: f.id === id ? comp : f.comp }));
        } else {
            this.footers = [{ id, comp }, ...this.footers.slice()];
        }
    };

    @action unregisterFooter = (id: string): void => {
        this.footers = this.footers.filter(f => f.id !== id);
    };
}
